import '@/App.css';
import { Toaster } from '@/components/ui/sonner';
import LoadingScreen from '@/components/LoadingScreen';
import ScrollProgress from '@/components/ScrollProgress';
import Navbar from '@/components/Navbar';
import FloatingDonate from '@/components/FloatingDonate';
import Hero from '@/components/sections/Hero';
import About from '@/components/sections/About';
import Causes from '@/components/sections/Causes';
import Impact from '@/components/sections/Impact';
import Donate from '@/components/sections/Donate';
import Gallery from '@/components/sections/Gallery';
import Events from '@/components/sections/Events';
import FAQ from '@/components/sections/FAQ';
import Contact from '@/components/sections/Contact';
import Footer from '@/components/sections/Footer';

function App() {
  return (
    <div className="App relative" data-testid="app-root">
      <LoadingScreen />
      <ScrollProgress />
      <Navbar />
      <FloatingDonate />
      <main>
        <Hero />
        <About />
        <Causes />
        <Impact />
        <Donate />
        <Gallery />
        <Events />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <Toaster richColors position="bottom-right" />
    </div>
  );
}

export default App;
